
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.632.509h.012l.013-.001a4.613 4.613 0 013.52 1.333 5.327 5.327 0 011.314 3.832l-.001.015v.015c0 1.598-.803 3.296-2.422 5.087l-6.938 7.245-.005.006-.005.005a.157.157 0 01-.118.052h-.005a.16.16 0 01-.118-.052l-.005-.005-.005-.006-6.959-7.267-.008-.009-.009-.008a3.553 3.553 0 01-.248-.26 14.66 14.66 0 00-.292-.39c-.1-.13-.21-.276-.326-.433h0a10.023 10.023 0 01-.72-1.123 7.059 7.059 0 01-.55-1.358h0l-.004-.012a5.235 5.235 0 01-.243-1.52v-.023A5.327 5.327 0 011.79 1.84 4.629 4.629 0 015.31.508h.025c.425.003.846.08 1.244.227h0l.002.001c.432.158.84.372 1.214.638h0l.004.003c.355.246.696.512 1.02.796.28.248.543.511.79.79l.374.42.374-.42c.247-.278.51-.542.788-.789.327-.283.67-.55 1.024-.8h.001a5.15 5.15 0 011.214-.638h.002c.399-.148.82-.225 1.246-.227z","stroke":"#000"}})])
          )
        }
      }
    